import { Grid, Typography } from "@mui/material";
import { BoxSection } from "components/BoxSection/BoxSection";
import { ReactComponent as RefreshCcw04Icon } from "components/Icons/refresh-ccw-04.svg";
import { StatusValue } from "components/Table/StatusValue";
import { useMessage } from "hooks/intl";
import { OLPaper } from "OLPaper";
import { SegmentData, SegmentFEData } from "types/segments";
import { OLDate } from "utilities/dateFormat";
import { formatNumberValue } from "utilities/numbers";
import { getParts } from "../SegmentForm/EditSegment";
import { BasicSettings } from "./BasicSettings";
import { Rules } from "./Rules";
import { useStyles } from "./SingleSegment.styles";

export const SegmentDetails = ({
  segmentData,
  isStaticSegment,
}: {
  segmentData?: SegmentData;
  isStaticSegment: boolean;
}) => {
  const { message } = useMessage();
  const classes = useStyles();

  const metrics = [
    {
      label: message({ id: "members" }),
      value: formatNumberValue(segmentData?.customersCount),
    },
    {
      label: message({ id: "avgTransactionValue" }),
      value: formatNumberValue(segmentData?.averageTransactionAmount),
    },
    {
      label: message({ id: "avgNumberOfTransactions" }),
      value: formatNumberValue(segmentData?.averageTransactions),
    },
    {
      label: message({ id: "avgSpending" }),
      value: formatNumberValue(segmentData?.averageClv),
    },
  ];

  return (
    <>
      <Grid container>
        <Grid item xs={12} className={classes.metricsHeader}>
          <Typography className={classes.sectionTitle}>
            {message({ id: "metrics" })}
          </Typography>
          <StatusValue
            status="neutral"
            label={
              <>
                <RefreshCcw04Icon />
                {message({ id: "lastRecalculation" })}:{" "}
                {segmentData?.calculatedAt
                  ? OLDate(segmentData?.calculatedAt)
                  : "-"}
              </>
            }
          />
        </Grid>
      </Grid>
      <OLPaper noPadding className={classes.detailsWrapper}>
        <BoxSection items={metrics} />
      </OLPaper>
      <Typography className={classes.sectionTitle}>
        {message({ id: "segmentDetails" })}
      </Typography>
      <BasicSettings segmentData={segmentData} />{" "}
      {!isStaticSegment && (
        <>
          <Typography className={classes.sectionTitle}>
            {message({ id: "conditions" })}
          </Typography>
          {segmentData && (
            <Rules
              segmentData={
                {
                  ...segmentData,
                  parts: getParts(segmentData.parts),
                } as SegmentFEData
              }
            />
          )}
        </>
      )}
    </>
  );
};
